export default "__VITE_ASSET__KFD6WSX1__"